import { Browser, Os } from "../graphql/graphql";

// Map from Bowser's Os names to Epic oS type
export const osNameMap = new Map<string | undefined, Os>([
  ["Windows", Os.Windows],
  ["MacOS", Os.Mac],
  ["Linux", Os.Linux],
  ["Android", Os.Android],
  ["iOS", Os.Ios],
]);

// Map from Bowser's Browser names to Epic Browser type
export const browserNameMap = new Map<string | undefined, Browser>([
  ["Chrome", Browser.Chrome],
  ["Microsoft Edge", Browser.Edge],
  ["Safari", Browser.Safari],
  ["Firefox", Browser.Firefox],
  ["Internet Explorer", Browser.Ie],
]);
